export const DISTRICTS = ['Ramanathapuram', 'Chennai', 'Vellore', 'Tirunelveli', 'Madurai', 'Tiruchirappalli'];

export const RELIGIONS = ['Muslim', 'Hindu', 'Christian', 'Other'];

export const SUB_COMMUNITIES = ['Labbai', 'Rowther', 'Marakkayar', 'Kayalar', 'Dakhni', 'Sheik / Sayyid', 'Other'];

export const RESERVATION_CATEGORIES = ['BC-M (3.5%)', 'BC', 'MBC', 'SC', 'ST', 'OC'];

export const SCHEMES = ['PMAY-G (housing)', 'Post-matric scholarship', 'MGNREGA', 'Ujjwala (LPG)', 'Maternity benefit'];

export const WOMEN_WORK_TYPES = [
  'Home-based piece work (tailoring, beedi, agarbatti)',
  'Agricultural labour',
  'Salaried (govt / private)',
  'Self-employed / shop',
  'Domestic work',
];

export const WOMEN_WORKING_OPTIONS = ['None', '1', '2', '3 or more'];

export const STUDY_TYPES: { value: string; label: string }[] = [
  { value: 'secondary', label: 'Secondary data' },
  { value: 'primary_survey', label: 'Primary survey' },
  { value: 'qualitative', label: 'Qualitative' },
  { value: 'rti_based', label: 'RTI-based' },
];

export const STUDY_STATUSES: { value: string; label: string }[] = [
  { value: 'planning', label: 'Planning' },
  { value: 'field_active', label: 'Field active' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'year_2', label: 'Year 2' },
  { value: 'completed', label: 'Completed' },
];
